export default function CsharpLogicalOperators() {
  return (
    <h2>Csharp Logical Operators</h2>
  );
}
